'use client';

import { useEffect } from 'react';

const CUBIC_BASE_SVG =
  '<rect width="64" height="64" rx="14" fill="#09090b"/><rect x="12" y="12" width="40" height="40" rx="9" fill="#ffffff"/>';

const DEV_BADGE =
  '<rect x="0" y="32" width="64" height="32" rx="8" fill="#16a34a"/>' +
  '<text x="32" y="54" text-anchor="middle" font-size="22" font-weight="bold" font-family="sans-serif" fill="#fff">DEV</text>';

const DEV_FAVICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">${CUBIC_BASE_SVG}${DEV_BADGE}</svg>`;

const DEV_FAVICON_HREF = `data:image/svg+xml,${encodeURIComponent(DEV_FAVICON_SVG)}`;

export function DevFavicon() {
  useEffect(() => {
    const links = document.head.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]');

    if (links.length > 0) {
      for (const link of links) {
        link.href = DEV_FAVICON_HREF;
        link.type = 'image/svg+xml';
      }
    } else {
      const link = document.createElement('link');
      link.rel = 'icon';
      link.href = DEV_FAVICON_HREF;
      link.type = 'image/svg+xml';
      document.head.append(link);
    }
  }, []);

  return null;
}
